"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _followUps = require("@/api/follow-ups");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _admins = require("@/api/admins");
var _utils = require("@/utils");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _followUps.defaultFollowUpData);
    this.loading = false;
    this.leadId = null;
    this.adminList = [];
    this.rules = {
      agenda: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      comments: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
    this.pickerOptions = {
      disabledDate(time) {
        return time.getTime() <= Date.now() - 8.64e7;
      }
    };
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    // fetch admin users
    this.fetchAdminList();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.leadId = parseInt(this.$route.params && this.$route.params.leadId);
      this.formData = Object.assign({}, _followUps.defaultFollowUpData);
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _followUps.getFollowUpById)(id);
      this.formData = data;
      this.leadId = data.leadId;
      // Just for test
      const title = this.formData.agenda;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchAdminList() {
    try {
      this.adminList = await (0, _admins.getAdmins)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  validateDueDate() {
    if (this.formData.assignedDate > this.formData.dueDate) {
      this.$alert('Due date should be greater than assigned date', 'Warning', {
        type: 'warning'
      });
      this.formData.dueDate = null;
      return false;
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.leadId = this.leadId;
      if (this.isEdit) {
        await (0, _followUps.updateFollowUp)(this.formData.id, this.formData);
      } else {
        await (0, _followUps.createFollowUp)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Folllow-up saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      _router.default.push('/follow-ups/list/' + this.leadId);
    } catch (err) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'FollowUpDetail',
  components: {}
})], default_1);
var _default = exports.default = default_1;